import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dropRight from 'lodash/dropRight';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { AdvanceList, AdvanceListItem } from '../../components/AdvanceList';
import VERTICALS from 'shared/lib/constants/verticals';
import * as analytics from 'shared/lib/analytics';

import './ClaimsNew.css';

class ClaimsNew extends Component {
  componentDidMount() {
    document.title = 'Start a claim - Sure';
    analytics.page('Portal - New Claim', {
      category: 'claim',
    });
  }

  handleSelectVertical(verticalCode) {
    analytics.track('Portal - Claim Vertical Clicked', {
      category: 'claim',
      label: verticalCode,
    });
  }

  render() {
    return (
      <div className="ClaimsNew">
        <div className="Container Container--small">
          <h1 className="ClaimsNew-heading">
            What type of claim are you trying to file?
          </h1>
          <AdvanceList>
            {map(filter(VERTICALS, 'claimable'), vertical => (
              <AdvanceListItem
                key={vertical.code}
                linkTo={`/account/claims/new/${vertical.code}/policies`}
                title={dropRight(vertical.description.split(' ')).join(' ')}
                onClick={this.handleSelectVertical.bind(this, vertical.code)}
              />
            ))}
          </AdvanceList>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(ClaimsNew)
);
